import React, {useState} from "react";
import './testAPI.style.scss'
import {get, post, responseValidator} from "../api";
import {toast} from "react-toastify";

export default function TestAPI() {
  const [method, setMethod] = useState()
  const [url, setURL] = useState()
  const [body, setBody] = useState()

  function submitHandler() {
    switch (method) {
      case 'GET':
        get(url).then(response => {
          console.log(response)
        })
        break;
      case 'POST':
        post(url, body).then(response => {
          console.log(response)
        })
        break;

    }
  }

  return (
    <div className='temx-test-api'>
      <input onChange={(e) => setMethod(e.target.value)} placeholder='GET-POST-...'/>
      <input onChange={(e) => setURL(e.target.value)} placeholder='URL , example : /Market'/>
      <textarea onChange={(e) => setBody(JSON.parse(e.target.value))} placeholder='BODY example : {
  "phoneNumber": "09213965567",
  "code": "12345"
}'/>
      <button onClick={submitHandler}>Apply</button>
    </div>
  );
}
